  // Menu Height Calc
    jQuery(window).scroll(function() {    
    var scroll = jQuery(window).scrollTop();
    if (scroll >= 80) {
        $("header").addClass("whitebg");
    } else {
        $("header").removeClass("whitebg");
    }
})

// Popup Trigger
 jQuery(document).ready(function () {
  $('.accordion-item').click(function (e) {
    // Prevent accordion toggle if clicking the popup link
    if ($(e.target).closest('.popup-trigger').length > 0) return;

    if (!$(this).hasClass('active')) {
      $('.accordion-item').removeClass('active');
      $('.accordion-title').removeClass('active');
      $(this).addClass('active');
      $(this).find('.accordion-title').addClass('active');
    } else {
      $(this).removeClass('active');
      $(this).find('.accordion-title').removeClass('active');
    }
  }); 
});

// Trademark Overwrite
	jQuery(document).ready(function ($) {
jQuery(function($) {	
const headings = document.querySelectorAll('h2, h3, h4, h5, a');
for (const heading of headings) {
  heading.innerHTML = heading.innerHTML
    .replace(/®/g, '<sup>®</sup>');
	
}
});
	});
  
  
  
  // Main Cart JS

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.add-to-cart-form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault(); // Stop normal POST form

        const formData = new FormData(form);
        const id = formData.get('id');
        const quantity = parseInt(formData.get('quantity')) || 1;

        CartJS.addItem(id, quantity, {}, {
          success: function (data, textStatus, jqXHR) {
            console.log('Added to cart:', data);
            // Optionally open your cart drawer
            document.getElementById('custom-cart-drawer')?.classList.add('open');
          },
          error: function (jqXHR, textStatus, errorThrown) {
            console.error('Add to cart error:', errorThrown);
          }
        });
      });
    });
  });


  // Global Accordions 

  document.addEventListener('DOMContentLoaded', function() {
    var accordionButtons = document.querySelectorAll('.accordion-button');
    accordionButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        var content = this.parentNode; // Get the content next to the button
        content.classList.toggle('active'); // Toggle the .active class
      });
    });
  });
  document.addEventListener('DOMContentLoaded', function() {
  var acc = document.getElementsByClassName("accordion");
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      this.classList.toggle("active");

      var panel = this.nextElementSibling;
      if (panel && panel.style.display === "block") {
        panel.style.display = "none";
      } else if (panel) {
        panel.style.display = "block";
      }
    });
  }
});